export default __webpack_public_path__ + "static/media/poster_2022_2.a3645f3f.png";